import {styled, Dialog, DialogTitle, DialogContent,} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CookiesPolicy from "./footerModals/cookiesPolicy";
import PrivacyPolicy from "./footerModals/privacyPolicy";
import TermsAndCondition from "./footerModals/Terms&Conditions";
import "./footer-modal.scss";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
interface modal {
  open: boolean;
  close: () => void;
  id: number;
}

const CustomizedDialogs = (props: modal) => {
  return (
      <BootstrapDialog 
      className="FooterModal"
        aria-labelledby="customized-dialog-title"
        PaperProps={{ sx: { borderRadius: "10px", maxHeight: "80vh", maxWidth: "1080px" },}}
        open={props.open}
        maxWidth="md" >
        <DialogTitle
          sx={{
            m: 0,
            p: "0 24px",
            lineHeight: "15px",
            borderBottom: "1px solid #EEEEEE",
            px: "1px",
            mx: "20px",
          }}
        >
          {props.id === 1 && (
            <p className="modalTitle grey-color fs-18">Cookies Policy</p>
          )}
          {props.id === 2 && (
            <p className="modalTitle grey-color fs-18">Privacy Policy</p>
          )}
          {props.id === 3 && (
            <p className="modalTitle grey-color fs-18">Terms & Condition</p>
          )}
          <IconButton
            aria-label="close"
            disableRipple
            onClick={props.close}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {props.id === 1 && <CookiesPolicy />}
          {props.id === 2 && <PrivacyPolicy />}
          {props.id === 3 && <TermsAndCondition />}
        </DialogContent>
      </BootstrapDialog>
  );
};
export default CustomizedDialogs;
